export default { version: '2.0.10', commit: 'a23d24940d8619a0bc8b33a46e224811e3d0d826' }
